import { create } from './create';

export const emailCampaignSubscribers = { create };
